import { InView } from 'react-native-intersection-observer'
import React from 'react'
import { AccordionModule } from './AccordionModule'
import { ICourseModulesNodes } from '@dtos/Course'

interface IContentsModulesProps {
  module: ICourseModulesNodes
  moduleId: string | string[]
  onLoadMore?: () => void
  isLastModule: boolean
  isModuleOpen: boolean
  isSubmodule: boolean
  isLastLessonOfPreviousModuleCompleted?: boolean
}

export function ContentsModules({
  module,
  isLastModule,
  isModuleOpen,
  onLoadMore,
  isSubmodule,
  isLastLessonOfPreviousModuleCompleted,
}: IContentsModulesProps) {
  const accordionModuleProps = {
    module,
    isLastModule,
    isModuleOpen,
    isSubmodule,
    isLastLessonOfPreviousModuleCompleted,
  }
  return (
    <React.Fragment key={module.id}>
      {isLastModule ? (
        <InView
          onChange={(inView) => inView && onLoadMore?.()}
          threshold={0.5}
          style={{
            flex: 1,
          }}
        >
          <AccordionModule {...accordionModuleProps} />
        </InView>
      ) : (
        <AccordionModule {...accordionModuleProps} />
      )}
    </React.Fragment>
  )
}
